import { useAuth } from '../../stores';
import { usePrivileges } from '../../utils';

function PartnersPageSubmenu({ renderItems, translate }) {
  const { privilegesReady, hasAnyPrivilege } = usePrivileges();
  const { auth } = useAuth();
  const privlg = auth.info?.privlg;
  const sentDisabled = (!privilegesReady) || (!hasAnyPrivilege(['partnerView', 'partnerEdit']));
  // Mirrors PartnersPage: the received side is gated on standing, not on a privilege
  const receivedDisabled = !['admin', 'manager', 'super']
    .some((priv) => privlg?.includes(priv));

  return renderItems([
    { label: translate('sentPlural'), link: 'sent', disabled: sentDisabled },
    { label: translate('receivedPlural'), link: 'received', disabled: receivedDisabled },
  ]);
}

export default PartnersPageSubmenu;
